<template lang="pug">
    v-dialog(v-model="value" scrollable persistent max-width=640)
        v-card 
            v-card-title.text-center {{title}}
            v-card-text
                | {{message}}

            v-card-actions.justify-center.mb-6
                v-btn.mr-6(v-if="cancelText!=''" rounded dark @click="$emit('input', false)" color="lightGray" min-width='112') {{cancelText}}
                v-btn(rounded dark @click="confirm" color="primary" min-width='112') {{confirmText}}
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    message: {
      type: String,
      default: ""
    },
    confirmText: {
      type: String,
      default: "Confirm"
    },
    cancelText: {
      type: String,
      default: ""
    },

    confirmAction: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    confirm() {
      this.$emit("input", false)
      this.confirmAction()
    }
  }
}
</script>
